import { Link } from 'react-router-dom';
import { Screen, Wordmark } from '../components/AppShell';
import { Icon, SectionHeader } from '../components/ui';
import { useAuth } from '../store/auth';
import { BRAND } from '../config/brand';
import './screens.css';

const LINKS = [
  { to: '/customers', icon: 'building', title: 'Customers', sub: 'Operators and their O-Licences' },
  { to: '/planner', icon: 'calendar', title: 'Inspection planner', sub: 'Forward schedule for audit' },
  { to: '/defects', icon: 'warning', title: 'Open defects', sub: 'Faults awaiting rectification' },
  { to: '/reminders', icon: 'bell', title: 'Reminders', sub: 'Email alerts before things fall due' },
  { to: '/invoices', icon: 'invoice', title: 'Invoices', sub: 'Billing and payment status' },
];

const ADMIN_LINKS = [
  { to: '/staff', icon: 'user', title: 'Staff', sub: 'Who can sign inspections' },
  { to: '/settings', icon: 'spanner', title: 'Workshop settings', sub: 'Details printed on records' },
];

export default function More() {
  const user = useAuth((s) => s.user);
  const tenant = useAuth((s) => s.tenant);
  const logout = useAuth((s) => s.logout);
  const isAdmin = user?.role === 'owner' || user?.role === 'admin';

  return (
    <Screen title="More" subtitle={tenant?.name}>
      <div className="stack-5">
        <div className="panel divide menu-list">
          {LINKS.map((link) => (
            <Link key={link.to} to={link.to} className="listrow">
              <span className="menu-icon">
                <Icon name={link.icon} size={19} />
              </span>
              <div className="grow">
                <div className="listrow-title">{link.title}</div>
                <div className="listrow-sub">{link.sub}</div>
              </div>
              <span className="icon-chevron"><Icon name="chevron" size={16} /></span>
            </Link>
          ))}
        </div>

        {isAdmin && (
          <div className="stack">
            <SectionHeader title="Administration" />
            <div className="panel divide menu-list">
              {ADMIN_LINKS.map((link) => (
                <Link key={link.to} to={link.to} className="listrow">
                  <span className="menu-icon">
                    <Icon name={link.icon} size={19} />
                  </span>
                  <div className="grow">
                    <div className="listrow-title">{link.title}</div>
                    <div className="listrow-sub">{link.sub}</div>
                  </div>
                  <span className="icon-chevron"><Icon name="chevron" size={16} /></span>
                </Link>
              ))}
            </div>
          </div>
        )}

        <div className="card card-pad stack-2">
          <div className="row spread">
            <div>
              <div className="listrow-title">{user?.name}</div>
              <div className="listrow-sub">
                {user?.position ?? 'No position set'}
                <span className="dot" />
                {user?.role}
              </div>
            </div>
            <Link to="/settings" className="btn btn-ghost btn-sm">
              Account
            </Link>
          </div>
        </div>

        <button className="btn btn-ghost btn-block" onClick={() => logout()}>
          <Icon name="logout" size={18} />
          Sign out
        </button>

        <footer className="dash-foot">
          <Wordmark size="sm" />
          <p className="tiny dim">{BRAND.legalNote}</p>
        </footer>
      </div>
    </Screen>
  );
}
